module.exports = __webpack_public_path__ + "static/media/informationVector.7df623e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/informationVector.svg
// module id = 1264
// module chunks = 3